import type { ButtonHTMLAttributes, ReactNode } from 'react'

import estilos from './Boton.module.css'

type Variante = 'principal' | 'secundario' | 'acento' | 'plano' | 'peligro'
type Tamano = 'pequeno' | 'normal' | 'grande'

type PropsBoton = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: Variante
  tamano?: Tamano
  /** Mientras es true el botón se bloquea y muestra el girador. */
  trabajando?: boolean
  completo?: boolean
  icono?: ReactNode
}

export function Boton({
  variante = 'secundario',
  tamano = 'normal',
  trabajando = false,
  completo = false,
  icono,
  children,
  disabled,
  className,
  type = 'button',
  ...resto
}: PropsBoton) {
  const clases = [
    estilos.boton,
    estilos[variante],
    tamano !== 'normal' ? estilos[tamano] : '',
    completo ? estilos.completo : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      className={clases}
      // Un botón que ya está guardando no se puede volver a oprimir: eso es
      // lo que crea órdenes duplicadas cuando la conexión está lenta.
      disabled={disabled || trabajando}
      aria-busy={trabajando}
      {...resto}
    >
      {trabajando ? <span className={estilos.girador} aria-hidden="true" /> : icono}
      {children}
    </button>
  )
}
